import axios from 'axios';
import { logger } from '../utils/logger';

const AUTH_TOKEN_STORAGE_KEY = 'authToken';

// Detectar automaticamente a URL da API sem hardcode de IP/domínio
const getApiBaseURL = () => {
  // Em desenvolvimento, prefira proxy do Vite para evitar problemas de cookie/CORS
  if (import.meta.env.DEV) {
    return '/api';
  }

  // Em produção com HTTPS, usa mesmo host
  if (window.location.protocol === 'https:') {
    return `${window.location.protocol}//${window.location.hostname}/api`;
  }

  // Fallback HTTP mantendo host atual
  return `${window.location.protocol}//${window.location.hostname}:3000/api`;
};

export const API_BASE_URL = import.meta.env.VITE_API_URL || getApiBaseURL();

// Cliente Axios configurado com interceptadores
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Permite cookies HttpOnly
  timeout: 10000,
});

// Interceptador de requisição - cookie HttpOnly + fallback Bearer token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptador de resposta - trata erros de autenticação
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { config, response } = error;
    
    // NÃO redirecionar durante tentativas de autenticação ou busca de clientes
    const isAuthEndpoint = config?.url?.includes('/auth/');
    const isClientSearch = config?.url?.includes('/clients/search');
    const isLoginPage = window.location.pathname === '/login';
    
    if (response?.status === 401 && !isAuthEndpoint && !isClientSearch && !isLoginPage) {
      // Apenas redirecionar se não for uma tentativa de auth ou busca de clientes
      // e o usuário não estiver já na página de login
      logger.warn('Token expirado, redirecionando para login...');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
